import React, { Suspense } from "react";
import { StyleSheet, ScrollView } from "react-native";
import Loading from "@components/atoms/Loading";
import Spacer from "@components/atoms/Spacer";
import { View } from "@components/atoms/Themed";
import NavigationBar from "@components/molecules/NavigationBar";
import {
  usePreloadedQuery,
  useQueryLoader,
  graphql,
  PreloadedQuery,
} from "react-relay/hooks";
import { PersonalInformationScreenQuery } from "@generated/PersonalInformationScreenQuery.graphql";
import PersonalInformation from "@components/templates/PersonalInformation";
import { goBack } from "@navigation/navigate";
import _ from "lodash";

const personalInformationScreen = graphql`
  query PersonalInformationScreenQuery {
    influencer {
      ...PersonalInformation
    }
  }
`;

function ScreenContent({
  queryReference,
}: {
  queryReference: PreloadedQuery<PersonalInformationScreenQuery>;
}) {
  const { influencer } = usePreloadedQuery<PersonalInformationScreenQuery>(
    personalInformationScreen,
    queryReference
  );
  return <PersonalInformation influencerInfoFragment={influencer} />;
}

export default function PersonalInformationScreen() {
  const [queryReference, loadQuery, disposeQuery] =
    useQueryLoader<PersonalInformationScreenQuery>(personalInformationScreen);
  React.useEffect(() => {
    loadQuery({});
    return () => {
      disposeQuery();
    };
  }, [loadQuery, disposeQuery]);

  return (
    <View style={styles.container}>
      <NavigationBar onBack={goBack} title="本人情報" />
      <ScrollView style={styles.content}>
        <Spacer height={8} />
        <Suspense fallback={<Loading size="large" />}>
          {!_.isNil(queryReference) && (
            <ScreenContent queryReference={queryReference} />
          )}
        </Suspense>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
  },
});
